import { useEffect, useState } from "react";

// Legacy (v2) read-only support. This app talks to the legacy backend for everything; ONLY the
// read-only status is fetched from the v3 platform (which owns the flag). CORS for app.docplace.io
// and app.docplace.ai is allowed on the v3 gateway. Fully fail-safe: any error / no match →
// readOnly:false, so this can never break the legacy app — worst case the banner just doesn't show.
const V3_API = "https://api.v3.docplace.ai/gw";
export const V3_APP_URL = "https://app.v3.docplace.ai";

let cached = null; // { readOnly, migrated } once resolved
let inflight = null;

function currentCustomerId() {
  try {
    const dp = JSON.parse(localStorage.getItem("docplace") || "{}");
    return dp.customerId || null;
  } catch {
    return null;
  }
}

export async function fetchReadOnlyStatus() {
  if (cached) return cached;
  if (inflight) return inflight;

  const id = currentCustomerId();
  if (!id) {
    cached = { readOnly: false, migrated: false };
    return cached;
  }

  inflight = fetch(
    `${V3_API}/tenants/public/migration/read-only/${encodeURIComponent(id)}`,
    { method: "GET", headers: { Accept: "application/json" } },
  )
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      cached = { readOnly: !!d?.readOnly, migrated: !!d?.migrated };
      return cached;
    })
    .catch(() => {
      cached = { readOnly: false, migrated: false };
      return cached;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

// Sync getter for non-React code (upload guards). False until the first fetch resolves.
export function isReadOnlyCached() {
  return !!(cached && cached.readOnly);
}

// React hook: returns { readOnly, migrated, loading }.
export function useReadOnlyStatus() {
  const [state, setState] = useState(cached || { readOnly: false, migrated: false });
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    let alive = true;
    fetchReadOnlyStatus().then((s) => {
      if (alive) {
        setState(s);
        setLoading(false);
      }
    });
    return () => {
      alive = false;
    };
  }, []);

  return { ...state, loading };
}
